module.exports = __webpack_public_path__ + "img/17_BC18_hoard_gold_bugs.28557068.jpg";